import React, { useState, useEffect } from 'react';
import * as images from '../../../images/charts';
import { Link } from 'react-router-dom';
import MenuIcon from '@rsuite/icons/Menu';
import GridIcon from '@rsuite/icons/Grid';
import CheckIcon from '@rsuite/icons/Check';
import EditIcon from '@rsuite/icons/Edit';
import { Icon } from '@rsuite/icons';
import {
  Input,
  InputGroup,
  Table,
  Button,
  DOMHelper,
  ButtonGroup,
  CheckPicker,
  Checkbox,
  InputPicker,
  Stack,
  Breadcrumb,
  Divider,
  Panel,
  Modal,
  Col,
  ButtonToolbar,
  FlexboxGrid,
  Dropdown,
  IconButton,
  Tooltip,
  Whisper
} from 'rsuite';
import SearchIcon from '@rsuite/icons/Search';
import DrawerView from './DrawerView';
import { mockUsers } from '@/data/mock';
import { ImageCell, CheckCell, } from './Cells';
import { functionsIn } from 'lodash';
import axios from 'axios';



interface PaginationData {
  page: number;
  pageSize: number;
  pageCount: number;
  total: number;
}

interface MetaData {
  pagination: PaginationData;
}
const sizeUnit = [
  'SM',
  'M',
  'L',
  'XL'
].map(item => ({ label: item, value: item }));


const { getHeight } = DOMHelper;



const { Column, HeaderCell, Cell } = Table;
const defaultData = mockUsers(12);

const EditableCell = ({ rowData, dataKey, onChange, ...props }) => {
  const editing = rowData.status === 'EDIT';
  return (
    <Cell {...props} className={editing ? 'table-content-editing' : ''}>
      {editing ? (
        <input
          className="rs-input"
          defaultValue={rowData[dataKey]}
          onChange={event => {
            onChange && onChange(rowData.id, dataKey, event.target.value);
          }}
        />
      ) : (
        <span className="table-content-edit-span">{rowData[dataKey]}</span>
      )}
    </Cell>
  );
};

const ActionCell = ({ rowData, dataKey, onClick, ...props }) => {
  return (
    <Cell {...props} style={{ padding: '6px' }}>
      <Button
        appearance="default"
        active
        onClick={() => {
          onClick(rowData.id);
        }}
      >
        {rowData.status === 'EDIT' ? <Icon as={CheckIcon} /> : <Icon as={EditIcon} />}
      </Button>
    </Cell>
  );
};


const DataTable = () => {

  const [data, setData] = React.useState(defaultData);
  const [data123, setData123] = useState([]);
  const [meta123, setMeta123] = useState<MetaData>();
  useEffect(() => {
    const fetchData = async () => {
      const response = await fetch('http://192.168.1.83:1337/api/products?populate=*');
      const json = await response.json();
      setData123(json.data);
      setMeta123(json.meta)
    };
    fetchData();


  }, []);

  console.log(meta123);

  const handleChange = (id, key, value) => {
    const nextData = Object.assign([], data);
    nextData.find(item => item.id === id)[key] = value;
    setData(nextData);
  };
  const handleEditState = id => {
    const nextData = Object.assign([], data);
    const activeItem = nextData.find(item => item.id === id);
    activeItem.status = activeItem.status ? null : 'EDIT';
    setData(nextData);
  };

  const [showDrawer, setShowDrawer] = useState(false);
  const [checkedKeys, setCheckedKeys] = useState<number[]>([]);
  const [showtab, setShowtab] = useState(1);
  const [searchKeyword, setSearchKeyword] = useState('');
  const [open, setOpen] = React.useState(false);
  const [size, setSize] = React.useState();
  const [modeldata, setmodeldata] = React.useState([])


  const handleOpen = (value, prdcd) => {
    setSize(value);
    setOpen(true);
    const newArray = [...data123]
    const filteredData = newArray.filter(item => item.attributes.ProductId == prdcd);

    setmodeldata(filteredData)

  };
  const handleClose = () => setOpen(false);

  let checked = false;
  let indeterminate = false;

  if (checkedKeys.length === data.length) {
    checked = true;
  } else if (checkedKeys.length === 0) {
    checked = false;
  } else if (checkedKeys.length > 0 && checkedKeys.length < data.length) {
    indeterminate = true;
  }

  const handleCheckAll = (_value, checked) => {
    const keys = checked ? data.map(item => item.id) : [];
    setCheckedKeys(keys);
  };
  const handleCheck = (value, checked) => {
    const keys = checked ? [...checkedKeys, value] : checkedKeys.filter(item => item !== value);
    setCheckedKeys(keys);
  };



  const data1 = ['Eugenia', 'Bryan', 'Linda', 'Nancy', 'Lloyd', 'Alice', 'Julia', 'Albert'].map(
    item => ({ label: item, value: item })
  );

  const handletab = (e) => {
    setShowtab(e);
    const x = document.getElementById('row')
    const y = document.getElementById('second')
    if (x?.click) {
      x.hidden = true
    }
    if (x?.click) {
      y.hidden = false
    }

  };
  const handletab2 = (e) => {
    setShowtab(e);
    const x = document.getElementById('row')
    const y = document.getElementById('second')
    if (y?.click) {
      y.hidden = true
    }
    if (y?.click) {
      x.hidden = false
    }
  };
  
  const [isActive1, setIsActive1] = useState(false);
  const [isActive2, setIsActive2] = useState(true);

  const handleClick1 = ()=>{
    
    handletab(2)
    setIsActive1(!isActive1);
    setIsActive2(false);
  }
  const handleClick2 = ()=>{
    
    handletab2(1)
    setIsActive1(isActive2);
    setIsActive2(true);
    
  };
  const tooltip = (
    <Tooltip>
      List View
    </Tooltip>
  );
  const tooltip1 = (
    <Tooltip>
      Grid View
    </Tooltip>
  );

  const ip = 'http://192.168.1.83:1337';


  return (
    <>

      <Stack className="table-toolbar " justifyContent="space-between">
        <Stack direction='column' alignItems='flex-start'>
          <Stack direction='column' >
            <h3 className="title">All Products</h3>
            <Breadcrumb>
              <Breadcrumb.Item href="/dashboard">Home</Breadcrumb.Item>
              <Breadcrumb.Item>Product</Breadcrumb.Item>

            </Breadcrumb>
          </Stack>

          <Stack spacing={5}>
            <CheckPicker data={data1} size="xs" appearance="default" placeholder="Category" style={{ width: 116 }} />
            <CheckPicker data={data1} size="xs" appearance="default" placeholder="Sub Category" style={{ width: 116 }} />
            <CheckPicker data={data1} size="xs" appearance="default" placeholder="Color" style={{ width: 116 }} />
            <Button appearance="default" active onClick={() => setShowDrawer(true)}>
              More Filter
            </Button>
          </Stack>
        </Stack>

        <Stack direction='column' alignItems='flex-end' spacing={24}>
          <Stack direction='row' spacing={5}>
            <Dropdown title="Add Product" appearance="default" active>
              <div style={{ 'display': 'grid' }}>
                <Link className='link' to='/bulkproduct'><Dropdown.Item><div style={{ 'display': 'flex' }}><div></div><div><strong>Bulk Upload</strong><br /> Upload multiple products at once  </div></div></Dropdown.Item></Link>
                <Link className='link' to='/products-create'><Dropdown.Item><div style={{ 'display': 'flex' }}><div></div><div><strong >Single Upload</strong> <br /> Add a single product</div></div></Dropdown.Item></Link>
              </div>
            </Dropdown>
            <Button color="cyan" appearance="primary">
              Manage Product
            </Button>
          </Stack>
          <Stack spacing={5}>
            <InputGroup inside >
              <Input placeholder="Search" value={searchKeyword} onChange={setSearchKeyword} />
              <InputGroup.Addon>
                <SearchIcon />
              </InputGroup.Addon>
            </InputGroup>
            <ButtonToolbar>
              <ButtonGroup size="md">
                <Stack alignItems='flex-start' >
                  <Button active className={showtab === 2 ? "btn btn-outline-secondary active" : "btn btn-outline-secondary"} data-toggle="tooltip" title="List view" onClick={() => handletab(2)} id="ba" ><Icon as={MenuIcon} /></Button>
                  <Button active className={showtab === 1 ? "btn btn-outline-secondary active" : "btn btn-outline-secondary"} data-toggle="tooltip" title="Grid view" onClick={() => handletab2(1)} id="bb" ><Icon as={GridIcon} /></Button>
                </Stack>
              </ButtonGroup>
            </ButtonToolbar>
          </Stack>
        </Stack>
      </Stack>
      <Divider className='divide' />
      <div className={showtab === 1 ? 'row' : ''} id="row">
        <Panel>
          {meta123 && (
            <b style={{ marginLeft: '6px' }}>Total Products: {meta123.pagination.total}</b>
          )}
          <FlexboxGrid justify="space-between" style={{ textAlign: 'center' }}>
            {data123.map((item) => (
              <FlexboxGrid.Item as={Col} colspan={24} md={6}>
                <div className="col-md-3" onClick={() => handleOpen('md', item.attributes.ProductId)}>
                  <Panel className='box' bordered bodyFill style={{ display: 'inline-block', width: '100%' }}>
                    <img src={`${ip}${item.attributes.CoverImage.data.attributes.url}`} className='imgp' />
                    <div className="overlay">Quick Veiw</div>
                    <Panel>
                      <b>Product Name : {item.attributes.ProductName} </b>
                      <p>
                        Alias Code : {item.attributes.ProductId}
                      </p>
                    </Panel>
                  </Panel>
                </div>
              </FlexboxGrid.Item>
            ))}
          </FlexboxGrid>
        </Panel>
      </div>
      <div className={showtab === 2 ? "tableform" : ""} id='second' hidden>
        <Table
          data={data123}
          height={500}
          rowKey="id"
        >
          <Column width={50} align="center" fixed>
            <HeaderCell style={{ padding: 0 }}>
              <div style={{ lineHeight: '40px' }}>
                <Checkbox
                  inline
                  checked={checked}
                  indeterminate={indeterminate}
                  onChange={handleCheckAll}
                />
              </div>
            </HeaderCell>
            <CheckCell dataKey="id" checkedKeys={checkedKeys} onChange={handleCheck} />
          </Column>
          <Table.Column width={80} align="center" fixed>
            <Table.HeaderCell>S. No.</Table.HeaderCell>
            <Table.Cell dataKey="id" />
          </Table.Column>

          <Table.Column >
            <Table.HeaderCell>Alias Code</Table.HeaderCell>
            <Table.Cell dataKey={['attributes', 'ProductId']} />
          </Table.Column>

          <Table.Column >
            <Table.HeaderCell>Category</Table.HeaderCell>
            <Table.Cell dataKey={['attributes', 'Category']} />
          </Table.Column>

          <Table.Column >
            <Table.HeaderCell>P Code</Table.HeaderCell>
            <Table.Cell dataKey={['attributes', 'ProductCode']} />
          </Table.Column>

          <Table.Column >
            <Table.HeaderCell>Image</Table.HeaderCell>
            <Table.Cell dataKey='image' />
          </Table.Column>

          <Table.Column >
            <Table.HeaderCell>Collection</Table.HeaderCell>
            <Table.Cell dataKey={['attributes', 'HSNCode']} />
          </Table.Column>

          <Table.Column >
            <Table.HeaderCell>VSN Code</Table.HeaderCell>
            <Table.Cell dataKey={['attributes', 'HSNCode']} />
          </Table.Column>

          <Table.Column >
            <Table.HeaderCell>Buyer</Table.HeaderCell>
            <Table.Cell dataKey={['attributes', 'ProductName']} />
          </Table.Column>

          <Table.Column >
            <Table.HeaderCell>Product Type</Table.HeaderCell>
            <Table.Cell dataKey={['attributes', 'ProductType']} />
          </Table.Column>

          <Table.Column >
            <Table.HeaderCell>Length</Table.HeaderCell>
            <Table.Cell dataKey={['attributes', 'Length']} />
          </Table.Column>

          <Table.Column >
            <Table.HeaderCell>Width</Table.HeaderCell>
            <Table.Cell dataKey={['attributes', 'Width']} />
          </Table.Column>

          <Table.Column >
            <Table.HeaderCell>Height</Table.HeaderCell>
            <Table.Cell dataKey={['attributes', 'Height']} />
          </Table.Column>

          <Table.Column >
            <Table.HeaderCell>Unit</Table.HeaderCell>
            <Table.Cell dataKey={['attributes', 'SizeUnit']} />
          </Table.Column>

          <Table.Column >
            <Table.HeaderCell>Color</Table.HeaderCell>
            <Table.Cell dataKey={['attributes', 'Color']} />
          </Table.Column>

          <Table.Column >
            <Table.HeaderCell>Finish</Table.HeaderCell>
            <Table.Cell dataKey={['attributes', 'Finish']} />
          </Table.Column>

          <Table.Column >
            <Table.HeaderCell>CBM</Table.HeaderCell>
            <Table.Cell dataKey={['attributes', 'ProductName']} />
          </Table.Column>

          <Table.Column fixed='right'>
            <Table.HeaderCell>Action</Table.HeaderCell>
            <ActionCell dataKey="id" onClick={handleEditState} rowData={undefined} />
          </Table.Column>
        </Table>

        {/* <Table height={420} data={data123} >
        
          <Column width={50} align="center">
            <HeaderCell style={{ padding: 0 }}>
              <div style={{ lineHeight: '40px' }}>
                <Checkbox
                  inline
                  checked={checked}
                  indeterminate={indeterminate}
                  onChange={handleCheckAll}
                />
              </div>
            </HeaderCell>
            <CheckCell dataKey="id" checkedKeys={checkedKeys} onChange={handleCheck} />
          </Column>

          <Column width={100}>
            <HeaderCell>Alias Code</HeaderCell>
            <EditableCell  onChange={handleChange} rowData={undefined} dataKey='id' />
          </Column>

          <Column width={150}>
            <HeaderCell>Category</HeaderCell>
            <EditableCell dataKey={['attributes', 'ProductName']}onChange={handleChange} rowData={undefined} />
          </Column>

          <Column width={80}>
            <HeaderCell>P Code</HeaderCell>
            <EditableCell dataKey="followers" onChange={handleChange} rowData={undefined} />
          </Column>
          <Column width={80} align="center">
            <HeaderCell>Image</HeaderCell>
            <ImageCell dataKey="avartar" />
          </Column>
          <Column width={80}>
            <HeaderCell>Collection</HeaderCell>
            <EditableCell dataKey="stars" onChange={handleChange} rowData={undefined} />
          </Column>
          <Column width={80}>
            <HeaderCell>VSN Code</HeaderCell>
            <EditableCell dataKey="followers" onChange={handleChange} rowData={undefined} />
          </Column>
          <Column width={150}>
            <HeaderCell>Buyer</HeaderCell>
            <EditableCell dataKey="name" onChange={handleChange} rowData={undefined} />
          </Column>
          <Column width={150}>
            <HeaderCell>Product Type</HeaderCell>
            <EditableCell dataKey="name" onChange={handleChange} rowData={undefined} />
          </Column>
          <Column width={150}>
            <HeaderCell>Length</HeaderCell>
            <EditableCell dataKey="name" onChange={handleChange} rowData={undefined} />
          </Column>
          <Column width={150}>
            <HeaderCell>Width</HeaderCell>
            <EditableCell dataKey="name" onChange={handleChange} rowData={undefined} />
          </Column>
          <Column width={150}>
            <HeaderCell>Height</HeaderCell>
            <EditableCell dataKey="name" onChange={handleChange} rowData={undefined} />
          </Column>
          <Column width={150}>
            <HeaderCell>Unit</HeaderCell>
            <EditableCell dataKey="name" onChange={handleChange} rowData={undefined} />
          </Column>
          <Column width={150}>
            <HeaderCell>Color</HeaderCell>
            <EditableCell dataKey="name" onChange={handleChange} rowData={undefined} />
          </Column>
          <Column width={150}>
            <HeaderCell>Finish</HeaderCell>
            <EditableCell dataKey="name" onChange={handleChange} rowData={undefined} />
          </Column>
          <Column width={150}>
            <HeaderCell>CBM</HeaderCell>
            <EditableCell dataKey="name" onChange={handleChange} rowData={undefined} />
          </Column>
          <Column flexGrow={1} fixed="right">
            <HeaderCell>Action</HeaderCell>
            <ActionCell dataKey="id" onClick={handleEditState} rowData={undefined} />
          </Column>
        </Table> */}

      </div>
      {/* Modal Section Open*/}
      <Modal size={size} open={open} onClose={handleClose}>
        <Panel
          header={
            <Stack justifyContent="space-between">
              <span>Product Details</span>
            </Stack>
          }
        >
          <Stack direction='row' justifyContent='space-around'>
            {modeldata.map((item) => (
              <Stack><img src={`${ip}${item.attributes.CoverImage.data.attributes.url}`} className='imgp1' /></Stack>
            ))}
            <Stack>
              {modeldata.map((item) => (
                <div style={{ 'display': 'grid', 'gap': '10px', 'marginTop': '24px' }}>
                  <div style={{ 'display': 'flex' }}>
                    <h6 style={{ 'height': '4vh' }}><b>Alias Code :</b></h6><p style={{ 'marginLeft': '12px' }}>{item.attributes.ProductId}</p>
                  </div>
                  <div style={{ 'display': 'flex' }}>
                    <h6 style={{ 'height': '4vh' }}><b>Description :</b></h6><p style={{ 'marginLeft': '12px' }}>{item.attributes.Description}</p>
                  </div>
                  <div style={{ 'display': 'flex' }}>
                    <h6 style={{ 'height': '4vh' }}><b>Size :</b></h6><p style={{ 'marginLeft': '12px' }}>{item.attributes.SizeUnit}</p>
                  </div>
                  <div style={{ 'display': 'flex' }}>
                    <h6 style={{ 'height': '4vh' }}><b>Finish :</b></h6><p style={{ 'marginLeft': '12px' }}>{item.attributes.Finish}</p>
                  </div>
                  <div style={{ 'display': 'flex' }}>
                    <h6 style={{ 'height': '4vh' }}><b>Packing Pcs :</b></h6><p style={{ 'marginLeft': '12px' }}>Inner==0 Master==0</p>
                  </div>
                  <InputPicker placeholder='Size' data={sizeUnit} style={{ width: 100 }} />
                </div>
              ))}
            </Stack>
          </Stack>
        
       </Panel>
        </Modal>
        
        <div><p> <a href="http://hitouchtechnologies.com/" target="_blank">Hitouch Technologies (P) Ltd.</a></p></div>
      <DrawerView open={showDrawer} onClose={() => setShowDrawer(false)} />



    </>
  );
};

export default DataTable;